import request from "./http";
import qs from 'qs'

// 	 * 健康指数->获取健康指数设备列表
export function findDevicesList() {
    return request({
        url: "/health/findDevicesList",
        method: "get",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
    });
}


// 	 * 健康指数->根据设备编号查询健康指数总览
export function findDevicesHealth(params) {
    return request({
        url: "/health/findDevicesHealth",
        method: "get",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
          params
    });
}


// 	 * 健康指数->查询报警和事件信息
export function findAlarm(params) {
    return request({
        url: "/health/findAlarm",
        method: "get",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
          params
    });
}

// 	 * 健康指数->报警和事件信息数量统计
export function alarmStatistics(params) {
    return request({
        url: "/health/alarmStatistics",
        method: "get",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
          params
    });
}

// 	 * 健康指数->根据设备号查询电流曲线和温度曲线
export function findCurve(params) {
    return request({
        url: "/health/findCurve",
        method: "get",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
          params
    });
}


// 	 * 湘西机场BI看板->每小时刷新实时能耗
export function findRealTimeValue(params) {
    return request({
        url: "http://192.168.124.151:19000/airport/findRealTimeValue",
        method: "get",
        params
    });
}

// 	 * 湘西机场BI看板->今日用能分区域
export function findToDayAreaEnergy(params) {
    return request({
        url: "http://192.168.124.151:19000/airport/findToDayAreaEnergy",
        method: "get",
        params
    });
}


// 	 * 湘西机场BI看板->本月能用电、水、气-环比、同比
export function findToMonUnitEnergy(params) {
    return request({
        url: "http://192.168.124.151:19000/airport/findToMonUnitEnergy",
        method: "get",
        params
    });
}

// 	 * 湘西机场BI看板->航站楼实时负荷和能耗
export function findToUnitLoadAndEnergy(params) {
    return request({
        url: "http://192.168.124.151:19000/airport/findToUnitLoadAndEnergy",
        method: "get",
        params
    });
}

// 	 * 湘西机场BI看板->人均能耗
export function findToUnitPerCapitaEnergy(params) {
    return request({
        url: "http://192.168.124.151:19000/airport/findToUnitPerCapitaEnergy",
        method: "get",
        params
    });
}

// 	 * 湘西机场BI看板->年-月用能趋势
// dateType  时间年/月,可用值:YEAR,MON,DAY
export function findToYearOrMonUnitEnergy(params) {
    return request({
        url: "http://192.168.124.151:19000/airport/findToYearOrMonUnitEnergy",
        method: "get",
        params
    });
}

// 	 * 湘西机场BI看板->本年能耗累计量
export function findToYearUnitEnergy(params) {
    return request({
        url: "http://192.168.124.151:19000/airport/findToYearUnitEnergy",
        method: "get",
        params
    });
}